import { render, staticRenderFns } from "./ViewVideo.vue?vue&type=template&id=649d6208&scoped=true"
import script from "./ViewVideo.vue?vue&type=script&lang=js"
export * from "./ViewVideo.vue?vue&type=script&lang=js"
import style0 from "./ViewVideo.vue?vue&type=style&index=0&id=649d6208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649d6208",
  null
  
)

export default component.exports